import React from 'react';
import { Layout, Menu } from 'antd';
import { hasPermission, history,addVisitLog } from 'libs';
import styles from './layout.module.less';
import menus from '../routes';
import logo from './logo.png';
// the hook
import { useTranslation } from 'react-i18next';

let openKeys = [];
  for (let item of menus.filter(x => x.child)) {
    for (let sub of item.child) {
      // if (sub.path === initPath) {
      //   openKeys = [item.title]
      //   break loop
      // }
      openKeys.push(item.title)
    }
  }

export default function Sider(props) {
  const {t,i18n} = useTranslation();
  function makeMenu(menu) {
    if (menu.auth && !hasPermission(menu.auth)) return null;
    if (!menu.title||menu.hidden) return null;
    return menu.child ? _makeSubMenu(menu) : _makeItem(menu)
  }

  function _makeSubMenu(menu) {
    return (
      <Menu.SubMenu key={menu.title} title={<div className='subMenu'><span className={['icon',menu.icon].join(" ")}/><h2>{t(menu.title)}</h2></div>}>
        {menu.child.map(menu => makeMenu(menu))}
      </Menu.SubMenu>
    )
  }

  function _makeItem(menu) {
    return menu.hidden ? null : (
      <Menu.Item key={menu.path}>
        <span>{t(menu.title)}</span>
      </Menu.Item>
    )
  }

  function handleSelect(menu) {
    console.log(menu.key,'menu.key');
    console.log(history.location.pathname,'history.location.pathname');
    if (menu.key==='/user/customerFixedAssets') {
      addVisitLog({
        pageName: '我的固资管理',
        fromPageUrl: history.location.pathname,
        pageUrl:`${window.location.origin}${menu.key}`,
        eventCode: 'FixedAssetManagementLeftMenu',
        eventName: "我的固资管理",
      })
    }else if(menu.key==='/user/order') {
      addVisitLog({
        pageName: '我的订单',
        fromPageUrl: history.location.pathname,
        pageUrl:`${window.location.origin}${menu.key}`,
        eventCode: 'MyOrderLeftMenu',
        eventName: "我的订单",
      })
    }
    history.push(menu.key)
  }



  return (
    <Layout.Sider width={140} collapsed={false} className='mainSlider'>
      <div className={i18n.language==='en'?'logo logo-en':'logo'}>{t('个人中心')}</div>
      <div className={i18n.language==='en'?'menus menus-en':'menus'}>
        <Menu
          theme="light"
          mode="inline"
          className='menus'
          inlineIndent={0}
          defaultSelectedKeys={[props.initPath]}
          selectedKeys={[props.initPath]}
          defaultOpenKeys={openKeys}
          onSelect={menu => handleSelect(menu)}>
          {menus.map(menu => makeMenu(menu))}
        </Menu>
      </div>
    </Layout.Sider>
  )
}
